export enum Company {
    lovcash = 'lovcash',
    klikklak = 'klikklak',
}
